export default __webpack_public_path__ + "static/media/harvard.dd2c27a9.png";